import { render, staticRenderFns } from "./ItemPop.vue?vue&type=template&id=7ae2bc3a"
import script from "./ItemPop.vue?vue&type=script&lang=js"
export * from "./ItemPop.vue?vue&type=script&lang=js"
import style0 from "./ItemPop.vue?vue&type=style&index=0&id=7ae2bc3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports